   // components/context/ContactModalContext.js
   import { createContext, useContext, useState, useCallback } from "react";
   
   const ContactModalContext = createContext();
   
   export const ContactModalProvider = ({ children }) => {
     const [modalState, setModalState] = useState({ open: false, intent: null });
   
     const openModal = useCallback((intent) => {
       setModalState({ open: true, intent });
     }, []);
   
     const closeModal = useCallback(() => {
       setModalState((prev) => ({ ...prev, open: false }));
     }, []);
   
     return (
       <ContactModalContext.Provider value={{ ...modalState, openModal, closeModal }}>
         {children}
       </ContactModalContext.Provider>
     );
   };
   
   export const useContactModal = () => useContext(ContactModalContext);